import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, Chapter } from "./Reveal";
import { FAQS, IMAGES } from "../data/site";

export const Faq = () => (
  <section className="py-20 lg:py-28" data-testid="faq-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
      <div className="lg:col-span-5">
        <Chapter number="06" label="Domande frequenti" />
        <Reveal delay={0.08}>
          <h2 className="font-serif text-3xl sm:text-4xl font-normal tracking-tight mt-5 text-[#1C1E1D]">
            Ciò che mi chiedono più spesso
          </h2>
        </Reveal>
        <Reveal delay={0.14} className="mt-8">
          <div className="overflow-hidden rounded-2xl spotlight-img">
            <img src={IMAGES.hourglass} alt="Dettaglio dello studio: una clessidra, simbolo del tempo dedicato a sé"
                 className="w-full h-80 lg:h-[420px] object-cover hover:scale-105 transition-transform duration-700" data-testid="faq-image" />
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.14} className="lg:col-span-7 lg:pt-16">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-[#1C1E1D]/10">
              <AccordionTrigger data-testid={`faq-question-${i}`}
                                className="text-left font-serif text-lg text-[#1C1E1D] hover:text-[#C85A32] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#525754] leading-relaxed pb-6" data-testid={`faq-answer-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
